export default __webpack_public_path__ + "static/media/EDITAL 11.2023.SEDEC.SINE..11414332.pdf";